export const dict = {
  pt_BR: {
    "Sign In with Google": "Entrar com Google",
    "Sign In with Facebook": "Entrar com Facebook",
    "Sign in with AWS": "Entrar com AWS",
    or: "ou",
    access_social_providers: "Você pode acessar via redes sociais: ",
    Admin: "Administrativo",
    "Sign In": "Entrar",
    "Sign Up": "Cadastre-se",
    "Sign Out": "Sair",
    "Forgot Password": "Esqueci a senha",
    Username: "Usuário",
    Password: "Senha",
    "Confirm Password": "Confirmar senha",
    "Change Password": "Mudar senha",
    Change: "Mudar",
    "New Password": "Nova senha",
    "New Rep-Password": "Confirme a nova senha",
    Email: "Email",
    "User is disabled": "Usuário desabilitado, entre em contato com o suporte",
    "User is disabled.": "Usuário desabilitado, entre em contato com o suporte",
    "Phone Number": "Telefone",
    "Phone Number (optional)": "Telefone (opcional)",
    "Confirm a Code": "Confirmar um código",
    "Confirm Sign In": "Confirmar ínicio de sessão",
    "Confirm Sign Up": "Confirmar cadastro",
    "Back to Sign In": "Já possuo conta.",
    "Send Code": "Enviar código",
    Confirm: "Confirmar cadastro",
    "Resend a Code": "Reenviar um código",
    Submit: "Salvar",
    Skip: "Pular",
    Verify: "Verificar",
    "Verify Contact": "Verificar contato",
    Code: "Código",
    Recpassword: "Os campos para nova senha não são iguais",
    "Account recovery requires verified contact information":
      "Para recuperar sua conta é necessário verificar suas informações de contato",
    "User does not exist":
      "Email não identificado. Caso tenha acabado de realizar seu cadastro, tente logar novamente em 5 minutos.",
    "User already exists":
      "Este e-mail já foi cadastrado. Faça login ou recupere sua senha.",
    "Incorrect username or password":
      "O e-mail e senha informados não se correspondem ou não existem.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number":
      "Tivemos um problema ao  tentar enviar o e-mail de recuperação, por favor, entre em contato com o suporte.",
    "Invalid password format":
      "Para que sua senha seja válida ela precisa possuir um total de 6 caracteres e dentre eles ter 1 letra maiúscula, 1 letra minúscula.",
    "Invalid phone number format": `Número de telefone inválido. Ex.: +12345678900`,
    "The following fields need to be filled out: ":
      "Verifique os seguintes campos: ",

    "Sign in to your account": "Entrar",
    "Enter your username": "Seu email",
    "Enter your password": "Sua senha",
    "Enter your email": "Seu email",
    "Enter your code": "Seu código",
    "Forget your password? ": " ",
    "Reset password": "Esqueci minha senha",
    "No account? ": "Ainda não tem conta?",
    "Create Account": "Cadastre-se.",
    "Create account": "Cadastre-se.",
    "Create a new account": "Crie sua conta",
    "Have an account? ": "Já possui uma conta? ",
    "Sign in": "Entrar",
    "Reset your password": "Recupere sua senha",
    "Username cannot be empty":
      "Para continuar, por favor, preencha corretamente o campo e-mail.",
    "null invocation failed due to configuration.":
      "Para continuar, por favor, preencha corretamente o campo de senha.",
    "An account with the given email already exists.":
      "Este e-mail já foi cadastrado. Faça login ou recupere sua senha.",
    "An account with the given email already exists":
      "Este e-mail já foi cadastrado. Faça login ou recupere sua senha.",
    "Confirmation Code *": "Já existe um usuário com esse email",
    "Full Name": "Nome",
    Continue: "Continuar",
    Register: "Cadastrar",
    "The following fields need to be filled out: Full Name, Email, Phone Number, Password":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Email, Telefone e Senha.",
    "The following fields need to be filled out: Full Name, Email, Password":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Email e Senha.",
    "The following fields need to be filled out: Email, Password":
      "Os seguintes campos precisam ser preenchidos: Email, Senha.",
    "The following fields need to be filled out: Full Name, Password":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Senha.",
    "The following fields need to be filled out: Full Name, Email":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Email.",
    "The following fields need to be filled out: Full Name, Phone Number":
      "Os seguintes campos precisam ser preenchidos: Nome Completo e Telefone.",
    "The following fields need to be filled out: Email, Phone Number":
      "Os seguintes campos precisam ser preenchidos: Email e Telefone.",
    "The following fields need to be filled out: Phone Number, Password":
      "Os seguintes campos precisam ser preenchidos: Telefone e Senha.",
    "The following fields need to be filled out: Email, Phone Number, Password":
      "Os seguintes campos precisam ser preenchidos: Email, Telefone e Senha.",
    "The following fields need to be filled out: Full Name, Email, Phone Number":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Email e Telefone.",
    "The following fields need to be filled out: Full Name, Phone Number, Password":
      "Os seguintes campos precisam ser preenchidos: Nome Completo, Telefone e Senha.",
    "The following fields need to be filled out: Password":
      "A Senha é obrigatoria.",
    "The following fields need to be filled out: Email":
      "O Email é obrigatório.",
    "The following fields need to be filled out: Full Name":
      "O Nome Completo é obrigatório.",
    "The following fields need to be filled out: Phone Number":
      "O Telefone é obrigatório.",
    "Password did not conform with policy: Password not long enough":
      "A Senha não é longa o suficiente.",
    "Password cannot be empty": "O campo de senha não pode estar vazio",
    "Invalid email address format.":
      "Por favor, informe um e-mail com formato válido para continuar.",
    "Username/client id combination not found.":
      "O e-mail e senha informados não se correspondem ou não existem.",
    "Fill in your details":
      "Preencha seus dados e tenha acesso ao conteúdo agora mesmo",
    "Lost your code? ": "Não recebeu seu código? ",
    "Resend Code": "Reenviar código",
    "Confirmation Code": "Código de confirmação",
    "Code cannot be empty": "O código não pode estar vazio",
    "Invalid verification code provided, please try again.":
      "O código de confirmação informado não é válido.",
    "Attempt limit exceeded, please try after some time.":
      "Limite de tentativa excedido. Tente depois de algum tempo.",
    "Value at 'password' failed to satisfy constraint": "Senha Inválida",
    "Member must have length greater than or equal to 6":
      "Sua senha precisa conter pelo menos 6 caracteres",
    "Username should be an email":
      "Por favor, informe um e-mail com formato válido para continuar.",
    "User cannot be confirmed. Current status is CONFIRMED":
      "Este usuário já está confirmado",
    "Password does not conform to policy: Password must have lowercase characters":
      "Para que sua senha seja válida ela precisa possuir um total de 6 caracteres e dentre eles ter 1 letra maiúscula, 1 letra minúscula.",
    "Password does not conform to policy: Password must have uppercase characters":
      "Para que sua senha seja válida ela precisa possuir um total de 6 caracteres e dentre eles ter 1 letra maiúscula, 1 letra minúscula.",
    "Custom auth lambda trigger is not configured for the user pool.":
      "Tivemos um problema ao concluir seu login, por favor, tente novamente.",
    "Password attempts exceeded":
      "Limite de tentativas excedido. Tente depois de algum tempo.",
    "Temporary password has expired and must be reset by an administrator.":
      "Senha temporária expirada, entre em contato com o suporte"
  },
};
